// 社区分析
import http from "@/jslibs/axios/http";

// 社区分析-数量统计
export const communityNumStats = (data) => http.post("/web/report/communityNumStats", data);

// 社区分析-帖子与评论趋势
export const communityTrend = (data) => http.post("/web/report/communityTrend", data);

// 社区分析-帖子与评论列表-分页
export const communityStatList = (data) => http.post("/web/report/communityStatList", data);